






















import { Component, Prop, Vue } from 'vue-property-decorator'
import DropdownSelect from '@/app/ui/components/DropdownSelect/index.vue'

@Component({
  inheritAttrs: false,
  components: { DropdownSelect },
})
export default class PNDropdown extends Vue {
  @Prop({ required: true }) private fieldLabel!: string
  @Prop({ default: false }) private required!: boolean
  @Prop({ default: false }) private optional!: boolean
  @Prop() private fieldDescription!: string
  @Prop() private errorMessage!: string
}
